import { useLocation, Link } from "react-router-dom";

const QUICK_LINKS = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/store", label: "Store" },
  { to: "/about", label: "About Us" },
  { to: "/contact", label: "Contact" },
];

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 overflow-hidden">
      <h1 className="absolute inset-0 flex items-center justify-center text-[10rem] md:text-[18rem] font-black text-teal-600/5 select-none pointer-events-none z-0 leading-none">
        404
      </h1>

      <div className="relative z-10 max-w-lg">
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-teal-50 flex items-center justify-center">
          <i className="ri-compass-3-line text-3xl text-teal-600"></i>
        </div>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Page not found</h2>
        <p className="mt-3 text-gray-500 leading-relaxed">
          Sorry, we couldn&rsquo;t find the page you were looking for. It may have been moved or no longer exists.
        </p>
        <p className="mt-1 text-xs text-gray-400 font-mono break-all">{location.pathname}</p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-500 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            <i className="ri-home-5-line"></i> Back to Home
          </Link>
          <a
            href="https://wa.me/254724114555"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border border-gray-200 hover:border-teal-300 hover:text-teal-700 text-gray-700 font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            <i className="ri-customer-service-2-line"></i> Contact Us
          </a>
        </div>

        <div className="mt-10 pt-6 border-t border-gray-100">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Popular pages</p>
          <div className="flex flex-wrap gap-2 justify-center">
            {QUICK_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="text-sm px-3 py-1.5 rounded-full bg-gray-50 hover:bg-teal-50 text-gray-600 hover:text-teal-700 transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
